export default "__VITE_ASSET__D8cAJaLk__"